export default __webpack_public_path__ + "static/media/feather.aaacbaee.ttf";